import classNames from 'classnames';
import { IconWithText } from 'common/icon/icon-with-text.js';
import { IconV2 } from 'common/icon/iconV2.js';
import { ICheckedFilter } from 'types/location.js';

export interface LegendsFilterProps {
  filter: ICheckedFilter;
  idx: number;
  className?: string;
  checkboxFilterOnClick(f: ICheckedFilter): void;
}

export const LegendsFilter = ({ filter, idx, className, checkboxFilterOnClick: onCheckFilter }: LegendsFilterProps) => {
  const { icon, label, selected, key } = filter;
  const filterLabelId = `checkbox-${idx}`;
  const iconName = filter.selected ? 'check' : undefined;

  return (
    <label htmlFor={filterLabelId} className={classNames('Checkbox', className)} key={idx}>
      <input
        id={filterLabelId}
        className="Checkbox-input"
        type="checkbox"
        checked={selected}
        onChange={() => onCheckFilter({ icon, label, selected, key })}
      />
      <div className="Checkbox-label u-flex u-flexRow u-flexAlignItemsCenter">
        {icon ? (
          <IconWithText
            iconClass="svg-fill-font-color u-textSlate"
            icon={icon}
            classes="IconWithText--small IconWithText--vCenter flex-1 u-widthFull u-pR-xs"
          >
            <small data-legend-key={key}>{label}</small>
          </IconWithText>
        ) : (
          <small className="flex-1 u-widthFull" data-legend-key={key}>
            {label}
          </small>
        )}
        {iconName ? (
          <div className="svg--font-inline svg-background-link u-textWhite svg--fill-inherit">
            <IconV2 size={16} icon={iconName} />
          </div>
        ) : (
          <div
            className="svg-color-stroke--hover u-flex u-textWhite"
            style={{
              borderWidth: '1px',
              borderStyle: 'solid',
              borderRadius: '2px',
            }}
          >
            <div
              style={{
                height: '14px',
                width: '14px',
              }}
            />
          </div>
        )}
      </div>
    </label>
  );
};
